module.exports = __webpack_public_path__ + "img/case9-二更.ff497b6e.png";